<script>
import { formatPetGender } from "@utils/format-gender";
import formatDate from '@utils/format-date'
import { merchantComputed } from "@store/helpers";

export default {
  props: {
    petList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    formatDate,
    formatPetGender,
    openDialogPetEdit(petItem) {
      this.openDialogPet({
        type: 'edit',
        petItem
      })
    },
    openDialogPetAdd() {
      this.openDialogPet({
        type: 'add'
      })
    },
    openDialogPet({ type, petItem = {} }) {
      this.$globalDialog('DialogPet', {
        type,
        petItem,
        callbackEditPet: (submitData) => {
          this.$emit('callbackEditPet')
        },
        callbackNewPet: (submitData) => {
          this.$emit('callbackNewPet')
        },
        callbackRemovePet: (submitData) => {
          this.$emit('callbackRemovePet')
        }
      })
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.petSectionList">
    <div
      v-loading="$isLoading('fetchMemberPetList')"
      :element-loading-text="`取得${$t('site.USER')}資料中...`"
      class="d-md-none petSectionList__section"
    >
      <div
        v-for="(petItem, index) in petList"
        :key="`petItem-${index}`"
        class="petSectionList__item"
      >
        <div class="d-flex align-items-center">
          <div
            class="petSectionList__img"
            :style="{ backgroundImage: `url('${ petItem.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
          ></div>
          <div class="petSectionList__info">
            {{ petItem.name }}
            <template v-if="$globalCategoryVisible"> <br>{{ petItem.categoryTitle }} | {{ petItem.sizeTitle }}</template>
          </div>
        </div>
        <BaseButton
          class="isStylePrimary isText"
          @click="openDialogPetEdit(petItem)"
        >
          <i class="fontello fontello-edit fa-2x"></i>
        </BaseButton>
      </div>
      <div
        class="petSectionList__item isNew"
        @click="openDialogPetAdd"
      >
        <i class="fal fa-plus mr-2"></i> 新增{{$t('site.USER')}}資料
      </div>
    </div>
    <el-table
      v-loading="$isLoading('fetchMemberPetList')"
      :element-loading-text="`取得${$t('site.USER')}資料中...`"
      :data="petList"
      class="isStyleBase mb-5 d-none d-md-block"
      :class="{ 'isStyleDingBeauty': $globalIsDingBeauty }"
      @row-click="openDialogPetEdit"
    >
      <el-table-column v-slot="{ row }" label="照片" width="70">
        <div
          class="petSectionList__img"
          :style="{ backgroundImage: `url('${ row.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
        ></div>
      </el-table-column>

      <el-table-column v-slot="{ row }" :label="`${$t('site.USER')}名`">
        {{ row.name }}
      </el-table-column>

      <el-table-column v-slot="{ row }" label="性別" width="70">
        {{ formatPetGender(row.gender) }}
      </el-table-column>

      <el-table-column v-if="currentMerchant.petCategories.length > 1" v-slot="{ row }" :label="$t('site.FORM_CATEGORY')" width="70">
        {{ row.categoryTitle }}
      </el-table-column>

      <el-table-column v-if="currentMerchant.petCategories[0] && currentMerchant.petCategories[0].children.length > 1" v-slot="{ row }" :label="$t('site.FORM_SIZE')" width="190">
        {{ row.sizeTitle }}
      </el-table-column>

      <el-table-column v-if="$globalIsJtails" v-slot="{ row }" label="品種">
        {{ row.breed || '----' }}
      </el-table-column>

      <el-table-column v-slot="{ row }" label="生日" width="130">
        <span v-if="row.birthday" class="font-number">{{ formatDate(row.birthday, 'yyyy/MM/dd') }}</span>
        <span v-else>----</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="編輯" width="80" align="center">
        <BaseButton
          class="isStylePrimary isText"
          @click.stop.prevent="openDialogPetEdit(row)"
        >
          <i class="fontello fontello-edit fa-2x"></i>
        </BaseButton>
      </el-table-column>
    </el-table>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.petSectionList {
  :global {
    .petSectionList {
      &__section {
        margin-bottom: 2rem;
      }

      &__img {
        width: 50px;
        height: 50px;
        margin-right: 1rem;
        background-color: #E4E7E9;
        background-image: url('~@assets/images/reservation/pet-avatar-default@2x.png');
        background-position: center;
        background-size: cover;
        border: 1px solid rgba($color-gray-4, 0.3);
        border-radius: 100%;
      }

      &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1rem;
        margin-bottom: 0.5rem;
        background-color: #F7F9FA;

        &.isNew {
          align-items: center;
          justify-content: center;
          min-height: 82px;
          margin-top: 1rem;
          color: $color-gray-2;
          cursor: pointer;
          background-color: #FFF;
          border: 1px dashed #BBC3C9;
        }
      }

      &__info {
        @include unstyled;
      }
    }
  }
}
</style>
